export const generateData = (rows, query) => {
  const newData = rows.map((row, key) => {
    return {
      id: row.cols[0],
      followDate: row.cols[1],
      userId: row.cols[2],
      ssoId: row.cols[3],
      fullName: row.cols[4],
      phoneNumber: row.cols[5],
      nationalId: row.cols[6],
      username: row.cols[7],
      image: row.cols[8],
    };
  });

  return newData;
};
